import { get_domain_style } from "@/main";

export default {
  name: "PoweredBy",
  data: () => ({
    current_year: new Date().getFullYear()
  }),
  computed: {
    powered_by_name() {
      return get_domain_style().powered_by_name;
    }
  }
};